import React, { useState, useRef, useEffect } from 'react';
import { Play, Pause, Volume2 } from 'lucide-react';
const AUDIO_URL = "https://res.cloudinary.com/dab9nhevk/video/upload/v1772470292/introInglesreadytoplay_wiykci.mp3";
export function AudioPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);

  // Formato mm:ss
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  // Progreso en %
  const progress = duration > 0 ? currentTime / duration * 100 : 0;
  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  // Click en barra para saltar
  const handleSeek = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!audioRef.current || !duration) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const ratio = clickX / rect.width;
    audioRef.current.currentTime = ratio * duration;
  };
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    const onTimeUpdate = () => setCurrentTime(audio.currentTime);
    const onLoadedMetadata = () => setDuration(audio.duration);
    const onEnded = () => setIsPlaying(false);
    audio.addEventListener('timeupdate', onTimeUpdate);
    audio.addEventListener('loadedmetadata', onLoadedMetadata);
    audio.addEventListener('ended', onEnded);
    return () => {
      audio.removeEventListener('timeupdate', onTimeUpdate);
      audio.removeEventListener('loadedmetadata', onLoadedMetadata);
      audio.removeEventListener('ended', onEnded);
    };
  }, []);
  return <div className="w-full max-w-md mx-auto bg-black/80 border border-matrix/30 
      rounded-lg p-4 backdrop-blur-sm shadow-[0_0_15px_rgba(0,255,65,0.1)]" data-id="element-5">
      
      {/* Audio element oculto */}
      <audio ref={audioRef} src={AUDIO_URL} preload="metadata" data-id="element-6" />

      <div className="flex items-center gap-4" data-id="element-7">
        
        {/* Botón play/pause */}
        <button onClick={togglePlay} className="flex-shrink-0 w-12 h-12 rounded-full bg-matrix/10 
            border border-matrix hover:bg-matrix/20 flex items-center 
            justify-center text-matrix transition-colors" aria-label={isPlaying ? 'Pause' : 'Play'} data-id="element-8">
          {isPlaying ? <Pause size={20} data-id="element-9" /> : <Play size={20} className="ml-1" data-id="element-10" />}
        </button>

        <div className="flex-1" data-id="element-11">
          <div className="text-xs text-matrix mb-1 font-mono tracking-wider" data-id="element-12">
            ARE YOU READY TO PLAY: INTRO
          </div>

          {/* Barra de progreso clickeable */}
          <div className="h-1.5 bg-gray-800 rounded-full overflow-hidden cursor-pointer" onClick={handleSeek} data-id="element-13">
            <div className="h-full bg-matrix rounded-full relative transition-all duration-100" style={{
            width: `${progress}%`
          }} data-id="element-14">
              <div className="absolute right-0 top-0 bottom-0 w-2 
                bg-white/50 shadow-[0_0_5px_#fff]" data-id="element-15" />
            </div>
          </div>

          {/* Tiempos */}
          <div className="flex justify-between mt-1 text-[10px] 
            text-gray-500 font-mono" data-id="element-16">
            <span data-id="element-17">{formatTime(currentTime)}</span>
            <span data-id="element-18">{formatTime(duration)}</span>
          </div>
        </div>

        <Volume2 size={16} className="text-gray-500" data-id="element-19" />
      </div>
    </div>;
}